// import Vue from 'vue'
// import VueRouter from 'vue-router'
// import main from '../views/main.vue'

// Vue.use(VueRouter)

// const routes = [
//   {
//     path: '/',
//     name: 'main',
//     component: main
//   },
//   {
//     path: '/about',
//     name: 'about'
//     // route level code-splitting
//     // this generates a separate chunk (about.[hash].js) for this route
//     // which is lazy-loaded when the route is visited.
//     // component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
//   }
// ]

// const router = new VueRouter({
//   routes
// })

// export default router
import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  mode: 'hash', // 使用 history 模式
  routes: [
    {
      path: '/',
      name: 'main',
      component: () => import('../views/main.vue'),
    },
  ],
});